import { FC } from 'react';

import classes from './index.module.css';

type IProps = {};
const LinearLoader: FC<IProps> = () => {
    return (
        <div className={classes['bar-container']}>
            <div className={classes['bar']} />
        </div>
    );
};
export default LinearLoader;
